import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import 'react-loading-skeleton/dist/skeleton.css';
import 'video.js/dist/video-js.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import Header from './layouts/Header';
import './resources/styles/style.scss';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import { Container } from 'react-bootstrap';
import ScrollToTop from './ScrollToTop';
import VideosPage from './pages/VideosPage';
import 'plyr-react/dist/plyr.css';
import LoadingComponent from './components/LoadingComponent';
import JoinUsPage from './pages/JoinUsPage';

/**
 *
 * @returns {JSX.Element}
 */
function App(): JSX.Element {
  const loading = React.useRef<LoadingComponent>(null);

  return (
    <>
      <Container className="mt-5 bg-light text-dark">
        <BrowserRouter>
          <LoadingComponent ref={loading} />
          <Header loading={loading} />
          <div className="content" style={{ marginLeft: '2em' }}>
            <ScrollToTop>
              <Routes>
                <Route path="/" element={<HomePage category={1} loading={loading} />} />
                <Route path="/animations" element={<VideosPage loading={loading} />} />
                <Route path="/360" element={<HomePage category={3} loading={loading} />} />
                <Route path="/about" element={<AboutPage loading={loading} />} />
                <Route path="/contact" element={<ContactPage loading={loading} />} />
                <Route path="/join-us" element={<JoinUsPage loading={loading} />} />
              </Routes>
            </ScrollToTop>
          </div>
        </BrowserRouter>
      </Container>
    </>
  );
}

export default App;
